import { render, staticRenderFns } from "./OrderingPanel.vue?vue&type=template&id=e5c67348&"
import script from "./OrderingPanel.vue?vue&type=script&lang=js&"
export * from "./OrderingPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrderingPanel.vue?vue&type=style&index=0&id=e5c67348&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports